export const makeRestUrl = (path: string): string => {
  const sub_url = new URL(path, "https://protibimbok.github.io");
  const base = WPTB_CFG.API_BASE.replace(
    "wp-table-builder",
    "wp-table-builder/" + sub_url.pathname.replace(/^\//, "")
  );
  const url = new URL(base);
  const search = new URLSearchParams(url.search);
  const sub_search = new URLSearchParams(sub_url.search);
  sub_search.forEach((value, key) => {
    search.set(key, value);
  });
  url.search = search.toString();
  return url.toString();
};

export type ApiPostDataTpe = FormData | Record<string, any>;

export const apiPost = async <T = any>(
  url: string,
  data: ApiPostDataTpe,
  init?: RequestInit
): Promise<[T, Response]> => {
  let body: any = data,
    contentType = "application/json";
  if (typeof data === "object" && !(data instanceof FormData)) {
    body = JSON.stringify(data);
  } else if (data instanceof FormData) {
    contentType = "multipart/form-data";
  }
  const response = await fetch(makeRestUrl(url), {
    ...init,
    method: "POST",
    body,
    headers: {
      "Content-Type": contentType,
      ...init?.headers,
      "X-WP-Nonce": WPTB_CFG.NONCE.wp_rest,
    },
  });
  return [(await response.json()) as T, response];
};

export const apiGet = async <T = any>(
  url: string,
  init?: RequestInit
): Promise<T> => {
  const response = await fetch(makeRestUrl(url), {
    ...init,
    headers: {
      ...init?.headers,
      "X-WP-Nonce": WPTB_CFG.NONCE.wp_rest,
    },
  });
  return await response.json();
};
